interface Report {
  month: string;
  visits: string;
  conversions: string;
  keywords: string;
  cpc: string;
  change: string;
  up: boolean;
}

const reports: Report[] = [
  { month: 'Február 2025', visits: '4 821', conversions: '47', keywords: '312', cpc: '0.34 €', change: '+18 %', up: true },
  { month: 'Január 2025', visits: '4 108', conversions: '43', keywords: '298', cpc: '0.37 €', change: '+11 %', up: true },
  { month: 'December 2024', visits: '3 710', conversions: '39', keywords: '275', cpc: '0.41 €', change: '+5 %', up: true },
  { month: 'November 2024', visits: '3 522', conversions: '37', keywords: '261', cpc: '0.42 €', change: '+3 %', up: true },
];

export default function PortalReporty() {
  return (
    <div className="p-6 flex flex-col gap-5 overflow-y-auto h-full">
      <p className="text-zinc-500 text-sm flex-shrink-0">Mesačné reporty za vaše aktívne kampane a projekty. Každý mesiac generujeme PDF zhrnutie so všetkými dátami.</p>

      <div className="space-y-4">
        {reports.map((r) => (
          <div key={r.month} className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden">
            {/* Header */}
            <div className="px-5 py-4 border-b border-zinc-800 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-orange-500/10 border border-orange-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-chart-line text-orange-400 text-base" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm">{r.month}</p>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${r.up ? 'bg-emerald-500/10 text-emerald-400' : 'bg-red-500/10 text-red-400'}`}>{r.change}</span>
                    <span className="text-zinc-600 text-xs">oproti predchádzajúcemu mesiacu</span>
                  </div>
                </div>
              </div>
              <button className="flex items-center gap-2 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 text-zinc-300 hover:text-white text-xs font-semibold px-3.5 py-2 rounded-lg cursor-pointer transition-all whitespace-nowrap">
                <i className="ri-download-2-line text-orange-400 text-sm" />
                PDF
              </button>
            </div>

            {/* Metrics */}
            <div className="grid grid-cols-2 sm:grid-cols-4 divide-x divide-zinc-800/50">
              {[
                { label: 'Návštevy', value: r.visits, icon: 'ri-user-line' },
                { label: 'Konverzie', value: r.conversions, icon: 'ri-checkbox-circle-line' },
                { label: 'Kľúč. slová', value: r.keywords, icon: 'ri-search-line' },
                { label: 'Avg. CPC', value: r.cpc, icon: 'ri-money-dollar-circle-line' },
              ].map((m) => (
                <div key={m.label} className="px-5 py-4 text-center">
                  <i className={`${m.icon} text-zinc-600 text-base mb-1`} />
                  <p className="text-white font-bold text-lg leading-none">{m.value}</p>
                  <p className="text-zinc-600 text-xs mt-1">{m.label}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
